import About from "./components/About";
import Contact from "./components/Contact";
import Home from "./components/Home";
import Navbar from "./components/Navbar";
import Skills from "./components/skills";
import WorkExperience from "./components/WorkExperience";

function App() {
  return (
    <div className="bg-[#230552]">
      <Navbar/>
      <Home/>
      <About/>
      <Skills/>
      <WorkExperience/>   
      <Contact/>
    </div>
  );
}

export default App;
